// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".teacher_dashboard_sidebar-component .teacher-user-info {\n  margin-bottom: 1.3rem; }\n\n.teacher_dashboard_sidebar-component .teacher-my-courses {\n  margin-bottom: 1.3rem; }\n\n.teacher_dashboard_sidebar-component .teacher-activity-calendar {\n  margin-bottom: 1.3rem; }\n\n@media screen and (max-width: 991px) {\n  .teacher_dashboard_sidebar-component .teacher-activity-calendar {\n    display: none; } }\n", ""]);
// Exports
module.exports = exports;
